// Global constants
export const TOGGLE_SHOW_EDITOR = "settings/TOGGLE_SHOW_EDITOR";
export const UPDATE_ALL = "settings/UPDATE_ALL";
export const SET_REDIRECT_AFTER_SAVE = "settings/SET_REDIRECT_AFTER_SAVE";
export const SET_HMT = "settings/SET_HMT";

// Local constants
export const TOGGLE_VISIBILITY = "TOGGLE_VISIBILITY";
export const UPDATE_SETTING = "UPDATE_SETTING";
export const SET_REDIRECTION_SETTINGS = "SET_REDIRECTION_SETTINGS";
export const SET_HMT_MUTATION = "SET_HMT_MUTATION";
